import { z } from 'zod';
const versionedIdentifier = z.string().min(5).max(160)
    .regex(/^[a-z][a-z0-9-]*(?:\.[a-z0-9-]+)+\.v[1-9][0-9]*$/);
export const relationshipsAssistantContextCapability = 'relationships.assistant-context.v1';
export const relationshipsAssistantContextProviderId = relationshipsAssistantContextCapability;
export const relationshipsAssistantContextSlot = 'platform.server.optional-context';
export const relationshipsAssistantContextRequestSchema = z.strictObject({
    requestId: z.string().uuid(),
    subjectType: z.literal('relationships.contact'),
    subjectId: z.string().uuid().nullable(),
    query: z.string().trim().max(160).nullable().optional(),
    requestedCapabilities: z.array(versionedIdentifier).min(1).max(50),
    redactionProfile: z.string().min(2).max(80).regex(/^[a-z][a-z0-9-]*$/),
    maxFacts: z.number().int().min(1).max(500),
});
export const relationshipsAssistantContextFactSchema = z.strictObject({
    factType: z.literal('relationships.contact-summary'),
    value: z.record(z.string().min(1).max(120), z.unknown()),
    sourceRevision: z.string().min(1).max(160),
    observedAt: z.string().datetime({ offset: true }),
    redactedFields: z.array(z.string().min(1).max(512)).max(100),
});
export const relationshipsAssistantContextResultSchema = z.strictObject({
    providerId: z.literal(relationshipsAssistantContextProviderId),
    providerModuleId: z.literal('relationships'),
    capability: z.literal(relationshipsAssistantContextCapability),
    facts: z.array(relationshipsAssistantContextFactSchema).max(1),
    unavailableReason: z.enum([
        'not-entitled',
        'not-enabled',
        'permission-denied',
        'provider-failed',
    ]).nullable(),
});
//# sourceMappingURL=relationships-assistant-context.contract.js.map